import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { couponsService } from '@/features/coupons';

export function useAffiliateCouponsQuery(affiliateId: string | undefined, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.coupons.list({ affiliateId }),
    queryFn: () => couponsService.list({ affiliateId: affiliateId! }),
    enabled: enabled && !!affiliateId,
  });
}
